import Raven from 'raven-js';
import { Children, createElement, useCallback, useEffect, useRef, useState } from 'react';
// @ts-expect-error dependency missing types
import UpgradeProductToApiNameMap from 'self-service-api/constants/UpgradeProductToApiNameMap';
import { omit } from '../../../utils';
import * as AdminModalTypes from '../constants/AdminModalTypes';
import { TEAM } from '../constants/AdminTypes';
import { getCanViewNewSeatRequestModal } from '../eligibility/getCanViewNewSeatRequestModal';
import { getIsAdmin } from '../eligibility/getIsAdmin';
import AdminModal from './AdminModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AdminOnlyWrapper = ({
  modalType = AdminModalTypes.DEFAULT,
  productLine,
  upgradeData,
  canViewNewSeats,
  adminType = TEAM,
  onClick,
  children,
  showSeatSelector
}) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [showAdminModal, setShowAdminModal] = useState(false);
  const [canViewNewSeatRequestModal, setCanViewNewSeatRequestModal] = useState(false);
  const _isMounted = useRef(true);
  const {
    upgradeProduct,
    apiName
  } = upgradeData;
  const apiNameToUse = canViewNewSeats && apiName ? apiName : UpgradeProductToApiNameMap[upgradeProduct];
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    getIsAdmin(adminType).then(isAdminResponse => {
      if (_isMounted.current) {
        setIsAdmin(isAdminResponse);
      }
    }).catch(() => {});
  }, [adminType]);
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    getCanViewNewSeatRequestModal().then(canViewNewSeatRequestModalResponse => {
      if (_isMounted.current) {
        setCanViewNewSeatRequestModal(canViewNewSeatRequestModalResponse);
      }
    }).catch(() => {});
    if (modalType === AdminModalTypes.REQUEST_QUOTE && !productLine) {
      Raven.captureException(new Error('Error in AdminOnlyWrapper: missing productLine for modalType REQUEST_QUOTE'));
    }
    return function cleanup() {
      _isMounted.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleToggleAdminModal = useCallback(() => {
    if (onClick) onClick();
    setShowAdminModal(!showAdminModal);
  }, [onClick, showAdminModal]);
  const child = Children.only(children);
  if (isAdmin) {
    return child;
  }
  const newProps = omit(Object.assign({}, child.props, {
    onClick: handleToggleAdminModal
  }), 'href');
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [showAdminModal && /*#__PURE__*/_jsx(AdminModal, {
      apiName: apiNameToUse,
      modalType: modalType,
      onClose: handleToggleAdminModal,
      productLine: modalType === AdminModalTypes.REQUEST_QUOTE ? productLine : undefined,
      upgradeData: upgradeData,
      canViewNewSeats: canViewNewSeats,
      showSeatSelector: showSeatSelector,
      canViewNewSeatRequestModal: canViewNewSeatRequestModal
    }), /*#__PURE__*/createElement(child.type, newProps)]
  });
};
export default AdminOnlyWrapper;